export const queryKeys = {
  health: ["health"] as const,
  profile: ["profile"] as const,
  directoryContactGroups: ["directory-contact-groups"] as const,
  directoryContacts: (groupId?: string | number, search?: string) =>
    ["directory-contacts", groupId ?? "all", search ?? ""] as const,
  callLogsRoot: ["call-logs"] as const,
  callLogs: (direction?: string, search?: string) =>
    ["call-logs", direction ?? "all", search ?? ""] as const,
  notesByNumber: (number: string) => ["notes-by-number", number] as const,
  chatConversations: (q?: string) => ["chat-conversations", q ?? ""] as const,
  chatConversation: (id: string) => ["chat-conversation", id] as const,
  chatTimeline: (id: string) => ["chat-timeline", id] as const,
  chatDirectory: (q?: string) => ["chat-directory", q ?? ""] as const,
  phoneQuickDials: ["phone-quick-dials"] as const,
  phoneCoverImages: ["phone-cover-images"] as const,
  phoneIconTypes: ["phone-icon-types"] as const,
} as const;
